import { instance } from "libs/api";

import { ApiRoutesRecommendation } from "../../constants";
import { UpdateSuggestionDiscountSettingsPayload } from "../../recommendation.types";

export const requestUpdateSuggestionDiscountSettings = async (
  payload: UpdateSuggestionDiscountSettingsPayload
): Promise<void> => {
  return await instance.patch(
    ApiRoutesRecommendation.SuggestionDiscount,
    payload
  );
};
